import Vue from 'vue';
import Router from 'vue-router';

import store from '../store';
import HomePage from '../components/home-page';
import Login from '../components/login';
import AudioCall from '../components/audio-call';
import VideoCall from '../components/video-call';
import checkInstructions from '../components/check-instructions';
Vue.use(Router);

export function createRouter() {
  const router = new Router({
    mode: 'hash',
    fallback: false,
    routes: [
      {
        path: '/',
        redirect: '/video-call',
        component: VideoCall
      },
      {
        path: '/login',
        component: Login
      },
      {
        path: '/audio-call',
        component: AudioCall
      },
      {
        path: '/video-call',
        component: VideoCall
      },
      {
        path: '/download',
        component: checkInstructions
      }
    ]
  });
  router.beforeEach((to, from, next) => {
    if (!store.state.isLogin) {
      if (to.fullPath !== '/login') {
        if (from.fullPath !== '/login') {
          if (to.path == '/download') {
            next();
          } else {
            next('/login');
          }
        }
        0;
      }
    }
    next();
  })
  return router;
}

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}